import { AppState } from '../../types';

export const getGravatars = (state: AppState) => state.gravatars;

export const getGravatarUrl = (state: AppState, email: string) => getGravatars(state)[email];
